export default __webpack_public_path__ + "static/media/whiteBackground_support.9ed985af.svg";